export default __webpack_public_path__ + "static/media/coresanscr25-webfont.4ee8db10.woff";